import Vue from 'vue'
import Router from 'vue-router'

import index from '~/pages/index'
import project from '~/pages/project'
import list from '~/pages/project-list'
import projectLstOld from '~/pages/project-list-old'
import promotion from '~/pages/promotion'
import test from '~/pages/test'
// import webComponent from '~/pages/web-component/index'

Vue.use(Router)

export function createRouter() {
  return new Router({
    mode: 'history',
    routes: [
      {
        path: '/company/:companyId',
        component: index
      },
      {
        path: '/company/:companyId/project/:projectId',
        component: project
      },
      {
        path: '/company/:companyId/project',
        component: list
      },
      {
        path: '/company/:companyId/project-list-old',
        component: projectLstOld
      },
      {
        path: '/company/:companyId/promotion/:promotionId',
        component: promotion
      },
      {
        path: '/company/65/testtest',
        component: test
      }
      // {
      //   path: '/company/:companyId/web-component',
      //   component: webComponent
      // }
    ],
    scrollBehavior(to, from, savedPosition) {
      return { x: 0, y: 0 }
    }
  })
}
